<p-toast position="bottom-center" [preventOpenDuplicates]="true"></p-toast>
<div [@routeAnimations]="prepareRouteTransition(outlet)">
    <router-outlet #outlet="outlet"></router-outlet>
</div>
